export const SET_PENDING_ACTION = 'SET_PENDING_ACTION'
export const RESET_PENDING_ACTION = 'RESET_PENDING_ACTION'
export const SET_MYPENDING_ACTION = 'SET_MYPENDING_ACTION'
export const RESET_MYPENDING_ACTION = 'RESET_MYPENDING_ACTION'
export const SET_MYINPROGRESS_TASKS = 'SET_MYINPROGRESS_TASKS'
export const RESET_MYINPROGRESS_TASKS = 'RESET_MYINPROGRESS_TASKS'
export const SET_MYGROUPPENDING_ACTION = 'SET_MYGROUPPENDING_ACTION'
export const RESET_MYGROUPPENDING_ACTION = 'RESET_MYGROUPPENDING_ACTION'
export const SET_MYGROUPUNASSIGN_TASKS = 'SET_MYGROUPUNASSIGN_TASKS'
export const RESET_MYGROUPUNASSIGN_TASKS = 'RESET_MYGROUPUNASSIGN_TASKS'
export const RESET_ALL = 'RESET_ALL'
//range part
export const SET_RANGE_PENDING_ACTION = 'SET_RANGE_PENDING_ACTION'
export const RESET_RANGE_PENDING_ACTION = 'RESET_RANGE_PENDING_ACTION'
export const SET_RANGE_MYGROUPPENDING_ACTION = 'SET_RANGE_MYGROUPPENDING_ACTION'
export const RESET_RANGE_MYGROUPPENDING_ACTION =
  'RESET_RANGE_MYGROUPPENDING_ACTION'
export const SET_RAF_PENDING_ACTION_CT06 = 'SET_RAF_PENDING_ACTION_CT06'
export const RESET_RAF_PENDING_ACTION_CT06 = 'RESET_RAF_PENDING_ACTION_CT06'
//range part
